import { OutboundFormMessage } from '$src/models/state';

export const _postMessage = (message: Partial<OutboundFormMessage>) => {
  window.parent.postMessage(JSON.stringify(message), '*');
};
